export default "__VITE_ASSET__hkM$FtaB__"